import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AppConfig } from 'src/app/common/model/appconfig';

@Injectable()
export class ConfigService {
    themeSet = JSON.parse(sessionStorage.getItem('theme'));

    config: AppConfig = {
        theme: this.themeSet ? this.themeSet.theme : 'rs-theme',//'lara-light-indigo',
        dark: this.themeSet ? this.themeSet.dark : false,//false,
        inputStyle: 'outlined',
        ripple: true
    };

    private configUpdate = new Subject<AppConfig>();

    configUpdate$ = this.configUpdate.asObservable();

    updateConfig(config: AppConfig) {
        this.config = config;
        this.configUpdate.next(config);
    }

    getConfig() {
        return this.config;
    }
}
